import React from 'react';
import {Container} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faFileLines, faWandMagicSparkles, faUserCheck,
    faRocket, faArrowsRotate, faArrowRightLong
} from '@fortawesome/free-solid-svg-icons';

const steps = [
    {
        num: '01',
        icon: faFileLines,
        accentClass: 'accent-secondary',
        action: 'Bring the documents.',
        detail: 'Regulations, policies, processes, clinical guidelines - whatever defines the decision you want to automate. PDFs, Word docs, intranet pages. No data engineering project to start.',
        getLabel: 'WHAT YOU GET',
        getText: 'A scoped pilot agreed in one hour. One decision, one domain, clear success criteria.'
    },
    {
        num: '02',
        icon: faWandMagicSparkles,
        accentClass: 'accent-primary',
        action: 'Build the knowledge base.',
        detail: 'The platform extracts the structure directly from your documents - obligations, prohibitions, conditions, exceptions. Each citation traced back to the source sentence.',
        getLabel: 'WHAT YOU GET',
        getText: 'A working knowledge base for your domain in days, not months. Every answer cites the document, page and paragraph.'
    },
    {
        num: '03',
        icon: faUserCheck,
        accentClass: 'accent-accent',
        action: 'Experts shape the last 20%.',
        detail: 'Compliance officers, clinicians, advisors highlight what matters, correct what\'s off, flag the edge cases. No ontologist required. Hours of expert time, not weeks.',
        getLabel: 'WHAT YOU GET',
        getText: 'A knowledge base that reflects how your team actually thinks. Every override captured and reusable.'
    },
    {
        num: '04',
        icon: faRocket,
        accentClass: 'accent-primary-dark',
        action: 'Ship a working solution.',
        detail: 'A live tool your stakeholders can use against real data. Decisions, citations, audit trail, override path. Three to four weeks from kick-off.',
        getLabel: 'WHAT YOU GET',
        getText: 'A working knowledge base, not a slide deck. Stakeholders evaluate the real system on real cases.'
    },
    {
        num: '05',
        icon: faArrowsRotate,
        accentClass: 'accent-secondary',
        action: 'It learns as your business moves.',
        detail: 'Regulations get amended - the knowledge base updates. Experts override decisions - the system gets smarter. New domains plug in alongside the first.',
        getLabel: 'WHAT YOU GET',
        getText: 'A system that compounds. Each new use case ships faster than the last. The business keeps moving, the system keeps up.'
    }
];

const HowItWorksSection = () => (
    <section id="how-it-works" className="how-it-works-section-v2">
        <Container>
            <div className="text-center mb-5">
                <div className="section-label">How It Works</div>
                <h2>From your documents to asking those important trusted questions about your business, in five steps.</h2>
                <p className="section-intro">
                    No multi-year programme. A clear path
                    from kick-off to a system your team actually uses.
                </p>
            </div>

            <div className="howitworks-track">
                {steps.map((s, i) => (
                    <div key={i} className={`howitworks-step ${s.accentClass}`}>
                        <div className="howitworks-step-rail">
                            <div className="howitworks-step-num">{s.num}</div>
                            <div className="howitworks-step-icon">
                                <FontAwesomeIcon icon={s.icon}/>
                            </div>
                            {i < steps.length - 1 && (
                                <div className="howitworks-step-connector"/>
                            )}
                        </div>
                        <div className="howitworks-step-body">
                            <h3 className="howitworks-step-action">{s.action}</h3>
                            <p className="howitworks-step-detail">{s.detail}</p>
                            <div className="howitworks-step-outcome">
                                <div className="howitworks-step-outcome-label">
                                    <FontAwesomeIcon icon={faArrowRightLong}/>
                                    <span>{s.getLabel}</span>
                                </div>
                                <p className="howitworks-step-outcome-text">{s.getText}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </Container>
    </section>
);

export default HowItWorksSection;